const COMMON_ERROR_CONCEPT = {
  name: '유형분류',
  option: [
    { name: '잘못된 유형 분류', id: 'CONCEPT_DIVISION' },
    { name: '개정 전 문제', id: 'CONCEPT_DIVISION_PROBLEM' },
  ],
}

export const ERROR_REPORT_PROBLEM_CUSTOM = [
  {
    name: '오류 종류',
    option: [
      { name: '문제 오류', id: 'ERROR_CATEGORY_PROBLEM' },
      { name: '정답 오류', id: 'ERROR_CATEGORY_ANSWER' },
      { name: '풀이 오류', id: 'ERROR_CATEGORY_SOLUTION' },
      { name: '디자인 및 레이아웃', id: 'ERROR_CATEGORY_LAYOUT' },
      { name: '단순 오타', id: 'ERROR_CATEGORY_TYPO' },
      { name: '기타', id: 'ERROR_CATEGORY_ETC' },
    ],
  },
  COMMON_ERROR_CONCEPT,
  {
    name: '난이도 제안',
    option: [
      {
        name: '하',
        id: 'LEVEL_SUGGESTION_LOWEST',
      },
      {
        name: '중하',
        id: 'LEVEL_SUGGESTION_LOW',
      },
      {
        name: '중',
        id: 'LEVEL_SUGGESTION_MIDDLE',
      },
      {
        name: '상',
        id: 'LEVEL_SUGGESTION_HIGH',
      },
      {
        name: '최상',
        id: 'LEVEL_SUGGESTION_HIGHEST',
      },
    ],
  },
  { name: '중복문제', option: [{ name: '중복된 문제', id: 'DUPLICATE_PROBLEM' }] },
] as const

export const ERROR_REPORT_PROBLEM_PUBLIC = [
  {
    name: '오류 종류',
    option: [
      { name: '정답 오류', id: 'ERROR_CATEGORY_ANSWER' },
      { name: '기타', id: 'ERROR_CATEGORY_ETC' },
    ],
  },
  COMMON_ERROR_CONCEPT,
] as const

export const ERROR_REPORT_PROBLEM_PUBLIC_ANSWER_NOT_CONFIRMED = [
  {
    name: '오류 종류',
    option: [
      { name: '정답이 없어서 불편', id: 'ERROR_CATEGORY_NEED_ANSWER' },
      { name: '기타', id: 'ERROR_CATEGORY_ETC' },
    ],
  },
  COMMON_ERROR_CONCEPT,
] as const

export const ERROR_REPORT_CONCEPT = [
  { name: '오타', id: 'ERROR_CATEGORY_TYPO' },
  { name: '내용 오류', id: 'ERROR_CATEGORY_CONTENT' },
  { name: '내용 누락', id: 'ERROR_CATEGORY_NONE_CONTENT' },
  { name: '그림 오류', id: 'ERROR_CATEGORY_LAYOUT' },
  { name: '그림 누락', id: 'ERROR_CATEGORY_NONE_LAYOUT' },
  { name: '내용 단축 필요', id: 'ERROR_CATEGORY_NEED_SHORTEN_CONTENT' },
  { name: '추가 정보 필요', id: 'ERROR_CATEGORY_LACK_CONTENT' },
  { name: '개념 배치 오류', id: 'ERROR_CATEGORY_MATCH' },
  { name: '기타', id: 'ERROR_CATEGORY_ETC' },
] as const

export const ERROR_REPORT_ARITHMETIC = [
  { name: '문제 오류', id: 'ERROR_CATEGORY_PROBLEM' },
  { name: '정답 오류', id: 'ERROR_CATEGORY_ANSWER' },
  { name: '풀이 오류', id: 'ERROR_CATEGORY_SOLUTION' },
  { name: '디자인 및 레이아웃', id: 'ERROR_CATEGORY_LAYOUT' },
  { name: '단순 오타', id: 'ERROR_CATEGORY_TYPO' },
  { name: '기타', id: 'ERROR_CATEGORY_ETC' },
] as const
